import CoreContactCardGrid from './CoreContactCardGrid';

export { type CoreContactCardGridProps } from './CoreContactCardGrid';
export default CoreContactCardGrid;
